<template>
  <el-dialog
    data-testid="cancel-reason-dialog"
    title="取消預約"
    :visible="true"
    width="480px"
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <ElInputWrapper>
      <div class="flex flex-col gap-[8px]">
        <p>請選擇取消原因<span class="text-danger">（必填）</span></p>
        <BaseElSelect
          v-model="reason"
          testName="cancelReasonCode"
          placeholder="請選擇原因…"
          style="width: 100%"
          :options="reasonOptions"
          @change="onReasonChange"
        />
        <p v-if="tried && !reason" class="text-danger text-sm">請選擇一項取消原因</p>

        <p class="mt-[8px]">
          備註
          <span v-if="isOtherSelected" class="text-danger">（必填）</span>
          <span v-else class="text-gray-60">（選填）</span>
        </p>
        <BaseElInput
          v-model="note"
          testName="cancelReasonNote"
          type="textarea"
          :rows="3"
          :maxlength="noteMaxLength"
          show-word-limit
          style="width: 100%"
          :placeholder="isOtherSelected ? '請說明取消原因…' : '可補充說明（選填）'"
        />
        <p v-if="tried && noteMissing" class="text-danger text-sm">選擇「其他」時請填寫原因</p>
      </div>
    </ElInputWrapper>
    <span slot="footer" class="dialog-footer">
      <BaseElButton plain @click="$emit('close')">關閉</BaseElButton>
      <BaseElButton type="danger" :disabled="!canSubmit" @click="handleConfirm">確認取消</BaseElButton>
    </span>
  </el-dialog>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { cancelReasonConfig } from '@/config/reservation'
import ElInputWrapper from '@/components/ElInputWrapper.vue'

export default defineComponent({
  name: 'CancelReasonDialog',
  components: { ElInputWrapper },
  emits: ['close', 'confirm'],
  setup (props, { emit }) {
    const noteMaxLength = 100
    const reason = ref('')
    const note = ref('')
    const tried = ref(false)

    const reasonOptions = Object.values(cancelReasonConfig).map(({ label, value }) => ({ label, value }))

    const isOtherSelected = computed(() => reason.value === 'other')
    const noteMissing = computed(() => isOtherSelected.value && note.value.trim().length === 0)
    const canSubmit = computed(() => !!reason.value && !noteMissing.value)

    const onReasonChange = (value) => {
      if (value !== 'other') note.value = ''
    }

    const handleConfirm = () => {
      tried.value = true
      if (!canSubmit.value) return
      emit('confirm', {
        cancelReasonCode: reason.value,
        cancelReasonNote: note.value.trim(),
      })
    }

    return {
      reasonOptions,
      reason,
      note,
      tried,
      noteMaxLength,
      isOtherSelected,
      noteMissing,
      canSubmit,
      onReasonChange,
      handleConfirm,
    }
  },
})
</script>

<style scoped lang="postcss"></style>
